module.exports = __webpack_public_path__ + "img/pe.4fb8c00.svg";